/**
 * @generated SignedSource<<677bb61316b88be7ee9acc0ac536ad51>>
 * @relayHash f88ba95894b1f560834fe455991f1ffd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/575.0.0-2026-09-01T15:23:24.101Z/createDesignProjectMutation

import { ConcreteRequest } from 'relay-runtime';
export type CreateDesignProjectMutationInput = {
  clientMutationId?: string | null;
  firmId: number;
};
export type createDesignProjectMutation$variables = {
  input: CreateDesignProjectMutationInput;
};
export type createDesignProjectMutation$data = {
  readonly createDesignProject: {
    readonly project: {
      readonly editUrl: string | null;
      readonly internalEditUrl: string | null;
    } | null;
  } | null;
};
export type createDesignProjectMutation = {
  response: createDesignProjectMutation$data;
  variables: createDesignProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalEditUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "editUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createDesignProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateDesignProjectMutationPayload",
        "kind": "LinkedField",
        "name": "createDesignProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "designProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "createDesignProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateDesignProjectMutationPayload",
        "kind": "LinkedField",
        "name": "createDesignProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "designProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/575.0.0-2026-09-01T15:23:24.101Z/createDesignProjectMutation",
    "metadata": {},
    "name": "createDesignProjectMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e2600b22615448d9f3f0c8fd64b50023";

export default node;
